<template>
  <el-table
    :data="billingContacts"
    stripe
    size="mini"
  >
    <el-table-column
      label="Name"
      :formatter="row => $_.get(row, 'name', '-')"
    />
    <el-table-column
      label="Email"
      :formatter="row => $_.get(row, 'email', '-')"
    />
  </el-table>
</template>

<script>
export default {
  props: {
    billingContacts: {
      type: Array,
      required: true
    }
  }
}
</script>

<style>

</style>
